import { createFileRoute } from "@tanstack/react-router";
import { useBarkAccountQuery } from "../../hooks/useBarkAccountQuery";

export const Route = createFileRoute("/app/account")({
  component: BarkAccountPage,
});

function BarkAccountPage() {
  const { barkAccountQuery } = useBarkAccountQuery();

  if (!barkAccountQuery.isSuccess) {
    return <div>loading</div>;
  }

  const account = barkAccountQuery.data;
  return (
    <>
      <h1>Accounts</h1>
      <ul>
        <li key={account.id}>
          <div className="account-list-item">
            <div>
              <h3>{account.name}</h3>
              <p>balance: {account.credits / 100}</p>
              <p>
                gpt4o mini request tokens:{" "}
                {account.gpt4o_mini_request_token_consumption}
              </p>
              <p>
                gpt4o mini consumption tokens:{" "}
                {account.gpt4o_mini_request_token_consumption}
              </p>
              <p>
                gpt4o request tokens: {account.gpt4o_request_token_consumption}
              </p>
              <p>
                gpt4o consumption tokens:{" "}
                {account.gpt4o_response_token_consumption}
              </p>
            </div>
            <button
              onClick={() => {
                window.open(account.top_up_payment_url, "_blank")?.focus();
              }}
            >
              top up
            </button>
          </div>
        </li>
      </ul>
    </>
  );
}
